export function parseGraphQLError(e) {
  if (Array.isArray(e))
    return {
      message: e
        .map(({ message }) => {
          return message || "";
        })
        .join(),
    };

  return e?.[0] || e || undefined;
}

export function createError({ name, options, message, defaultMessage = "" }) {
  const e = new Error(message || defaultMessage, options);
  e.name = name;

  return e;
}

export default createError;
